import * as React from "react";
import { LibraryBook } from "../../../assets/svg/LibraryBook";
import { IdStyles } from "../../../less/IdStyles";
import { SvgButton } from "../svg-button/SvgButton";
export var GridItemContainerLibrary = function (_a) {
    var children = _a.children, className = _a.className, onClick = _a.onClick;
    return (React.createElement(SvgButton, { name: IdStyles.LibraryBook, svg: LibraryBook, className: className, onClick: onClick }, children));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/GridItemContainerLibrary.tsx
// module id = 2698
// module chunks = 3